import { Attachment } from "./attachment";
import { ICArea } from "./icarea";
import { ICCameraOption } from "./iccameraoption";
import { ICCameraType } from "./iccameratype";
import { ICDeviceStatus } from "./icdevicestatus";
import { ICObjective } from "./icobjective";
import { Image } from "./image";
import { Translation } from "./translation";

export class ICCamera {
  Area: ICArea;
  Attachments: Attachment[];
  BaseImageId?: number;
  BaseImage?: Attachment;
  CameraOptions: ICCameraOption[];
  CameraType: ICCameraType;
  Code: string;
  DeleteDate: string;
  EndUpdateTime: string;
  FrequencyUpdate: string;
  Id: number;
  IdGuid: string;
  Images: Image[];
  InsertDate: string;
  LastCommunication: string;
  LastDownload: string;
  LastEditDate: string;
  LastReboot: string;
  Name: Translation[];
  NetworkDhcp: boolean;
  NetworkDns: string;
  NetworkGateway: string;
  NetworkIpAddress: string;
  NetworkMacAddress: string;
  NetworkSubnetMask: string;
  NetworkWifiPassword: string;
  NetworkWifiSSID: string;
  Objectives: ICObjective[];
  Order: number;
  PreviousReboot: string;
  StartUpdateTime: string;
  Status: ICDeviceStatus;
  StatusDescription: string;
  Wifi: boolean;

  constructor(data?: Partial<ICCamera>) {
    Object.assign(this, data);
  }
}
